"use client";

import React from "react";
import { Box, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { usePathname } from "next/navigation";
import Footer from "@/app/components/Footer";
import PublicHeader from "@/app/components/PublicHeader";

export default function PublicLayoutClient({ children }) {
  const theme = useTheme();
  const pathname = usePathname();
  const isSearchPage = pathname === "/search";
  const isSupportPage = pathname === "/support";
  const isJoinPage = pathname === "/join";
  const isRequestLanding = pathname?.startsWith("/r/");
  const isSeekerConfirmPage = pathname?.startsWith("/s/");

  // These pages manage their own full-screen layout (no header/footer)
  if (isJoinPage || isRequestLanding || isSeekerConfirmPage) {
    return children;
  }

  if (isSearchPage || isSupportPage) {
    return (
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100dvh",
          position: "relative",
          paddingTop: {
            xs: "0",
            md: 2,
          },
          paddingBottom: {
            xs: "0",
            md: 2,
          },
          paddingLeft: {
            xs: "0",
            md: 2,
          },
          paddingRight: {
            xs: "0",
            md: 2,
          },
        }}
      >
        <Box sx={{ position: "relative", zIndex: 20 }}>
          <PublicHeader />
        </Box>
        <Box
          sx={{
            flex: 1,
            position: "relative",
            zIndex: 1,
          }}
        >
          {children}
        </Box>
        <Footer hideCopyright={isSupportPage} />
      </Container>
    );
  }

  return (
    <Container
      maxWidth="lg"
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100dvh",
        position: "relative",
      }}
    >
      <PublicHeader />

      <Box
        sx={{
          flex: 1,
          position: "relative",
          zIndex: 5,
          paddingTop: theme.spacing(2),
        }}
      >
        {children}
      </Box>

      <Footer />
    </Container>
  );
}
